import { uuidv7 } from 'uuidv7';

/** UUID v7: time-ordered. */
export const generateId = uuidv7;
